import { render, staticRenderFns } from "./AddAlarmSetting.vue?vue&type=template&id=50326b04&scoped=true"
import script from "./AddAlarmSetting.vue?vue&type=script&lang=js"
export * from "./AddAlarmSetting.vue?vue&type=script&lang=js"
import style0 from "./AddAlarmSetting.vue?vue&type=style&index=0&id=50326b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50326b04",
  null
  
)

export default component.exports